import { useQuery } from "react-query";
import { merchants } from "services/merchants";

export const useFetchGetMerchant = (merchantId: string) =>
    useQuery<nuorder.merchant.v1.Merchant>(["MERCHANT", { merchantId }], () => merchants.fetchMerchant(merchantId), {
        enabled: merchantId,
    });
